export const urlApiProfile = "/hub/api/profile";
export class AccountApiError extends Error {
    status;
    constructor(status, message) {
        super(message);
        this.status = status;
        this.name = "AccountApiError";
    }
}
export const accountErrorMessage = (error) => error instanceof AccountApiError
    ? error.message
    : "Не удалось связаться с сервером. Проверьте соединение и попробуйте еще раз.";
export function createAccountApi(hubOrigin = "", onUnauthorized, decorateRequestUrl) {
    const origin = hubOrigin.replace(/\/$/, "");
    const url = (path) => `${origin}${path}`;
    async function request(path, method = "GET", signal) {
        const requestUrl = url(path);
        const response = await fetch(decorateRequestUrl?.(requestUrl) ?? requestUrl, {
            method,
            credentials: "include",
            cache: "no-store",
            headers: { Accept: "application/json" },
            ...(signal === undefined ? {} : { signal }),
        });
        const text = await response.text();
        if (!response.ok) {
            if (path !== "/hub/api/logout" && response.status === 401)
                onUnauthorized?.();
            const contentType = response.headers.get("content-type") ?? "";
            const message = response.status < 500 && contentType.startsWith("text/plain")
                ? text.trim()
                : "Произошла ошибка. Попробуйте позже.";
            throw new AccountApiError(response.status, message || "Произошла ошибка. Попробуйте позже.");
        }
        return (text.trim() ? JSON.parse(text) : undefined);
    }
    return {
        keys: {
            profile: url(urlApiProfile),
        },
        fetchProfile: (signal) => request(urlApiProfile, "GET", signal),
        logout: () => request("/hub/api/logout", "POST"),
    };
}
